<template>
  <div id="Plans" class="flex" cols="12" sm="12">
    <!-- <h1>SpookApp Plans</h1> -->
    <!-- <v-form v-model="valid" ref="form" lazy-validation> -->
    <v-container>
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <div class="pricingTable">
            <div class="pricingTable-header">
              <div class="icon">
                <v-icon>mdi-emoticon-happy</v-icon>
                <!-- <i class="fas fa-bicycle"></i> -->
              </div>
              <div class="price-value">
                <span class="currency">₹</span>
                <span class="amount">0</span>
              </div>
            </div>
            <div class="pricing-content">
              <h3 class="title">Standard</h3>
              <ul>
                <li>FLASHLIGHT TURN ON</li>
                <li>MUSIC PLAY</li>
                <li>VIBRATION</li>
                <li>BRIGHTNESS</li>
                <li>CAMERA OPEN</li>
                <li>BLUETOOTH</li>
                <li>SOUND</li>
                <li>HOSTPOT OPEN</li>
                <li>SCREENSHOT TAKE</li>
                <li>TURBO SEARCH</li>

                <li class="disable">SMS</li>
                <li class="disable">CONTACT LIST</li>
                <li class="disable">ON CALL</li>
                <li class="disable">CALL LOGS</li>
                <li class="disable">INSTALL APP</li>

                <li class="disable">WHATSAPP</li>
                <li class="disable">INSTAGRAM</li>
              </ul>
              <div class="pricingTable-signup">
                <a href="#">Life Time</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="pricingTable platinum">
            <div class="pricingTable-header">
              <div class="icon">
                <v-icon>mdi-emoticon-cool</v-icon>
                <!-- <i class="fas fa-bicycle"></i> -->
              </div>
              <div class="price-value">
                <span class="currency">₹</span>
                <span class="amount">{{plantium}}</span>
              </div>
            </div>
            <div class="pricing-content">
              <h3 class="title">PLANTIUM</h3>
              <ul>
                <li>FLASHLIGHT TURN ON</li>
                <li>MUSIC PLAY</li>
                <li>VIBRATION</li>
                <li>BRIGHTNESS</li>
                <li>CAMERA OPEN</li>
                <li>BLUETOOTH</li>
                <li>SOUND</li>
                <li>HOSTPOT OPEN</li>
                <li>SCREENSHOT TAKE</li>
                <li>TURBO SEARCH</li>

                <li>SMS</li>
                <li>CONTACT LIST</li>
                <li>ON CALL</li>
                <li>CALL LOGS</li>
                <li>INSTALL APP</li>

                <li>WHATSAPP</li>
                <li>INSTAGRAM</li>
              </ul>
              <div class="pricingTable-signup">
                <a href="#">Sign Up</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="pricingTable yellow">
            <div class="pricingTable-header">
              <div class="icon">
                <v-icon>mdi-emoticon</v-icon>
              </div>
              <div class="price-value">
                <span class="currency">₹</span>
                <span class="amount">{{gold}}</span>
              </div>
            </div>
            <div class="pricing-content">
              <h3 class="title">GOLD</h3>
              <ul>
               <li>FLASHLIGHT TURN ON</li>
                <li>MUSIC PLAY</li>
                <li>VIBRATION</li>
                <li>BRIGHTNESS</li>
                <li>CAMERA OPEN</li>
                <li>BLUETOOTH</li>
                <li>SOUND</li>
                <li>HOSTPOT OPEN</li>
                <li>SCREENSHOT TAKE</li>
                <li>TURBO SEARCH</li>

                <li>SMS</li>
                <li>CONTACT LIST</li>
                <li>ON CALL</li>
                <li>CALL LOGS</li>
                <li>INSTALL APP</li>

                <li class="disable">WHATSAPP</li>
                <li class="disable">INSTAGRAM</li>
              </ul>
              <div class="pricingTable-signup">
                <a href="#">Sign Up</a>
              </div>
            </div>
          </div>
        </div>
        <v-col cols="12" sm="4" md="4"></v-col>
        <v-col cols="12" sm="4" md="4">
          <v-switch v-model="switch1" inset color="red" :label="`Yearly ?: ${switch1.toString()}`"></v-switch>
        </v-col>
        <v-col cols="12" sm="4" md="4"></v-col>
      </div>

      <!-- <v-row>
          <v-col cols="12" md="4">   
            <center style="font-size: 40px;">
              <v-btn color="success" class="mr-4" @click="saveBrightness()">Save & Play</v-btn>
              <br />
            </center>
          </v-col>
            <v-col cols="12" md="4">   
            <center style="font-size: 40px;">
              <v-btn color="success" class="mr-4" @click="saveBrightness()">Save & Play</v-btn>
              <br />
            </center>
          </v-col>
             <v-col cols="12" md="4">   
            <center style="font-size: 40px;">
              <v-btn color="success" class="mr-4" @click="saveBrightness()">Save & Play</v-btn>
              <br />
            </center>
          </v-col>
      </v-row>-->

      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :right="x === 'right'"
        :top="y === 'top'"
        :color="color"
      >
        {{ text }}
        <v-btn color="blue" text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<style scoped>
.switch-center {
  display: flex;
  justify-content: center;
}
.pricingTable {
  background: #4ec2f4;
  font-family: "Poppins", sans-serif;
  text-align: center;
  padding: 0 20px 20px;
  margin: 50px 0 0;
  border-radius: 30px;
  position: relative;
  z-index: 1;
}
.pricingTable:after {
  content: "";
  background: #26a9f9;
  width: 100%;
  height: 60%;
  transform: translateY(-50%);
  position: absolute;
  top: 230px;
  left: 0;
  z-index: -2;
  clip-path: polygon(0 45%, 100% 0%, 100% 100%, 0 65%);
}
.pricingTable .pricingTable-header {
  padding: 15px;
}
.pricingTable .icon {
  color: #fff;
  background: #22a2f6;
  font-size: 30px;
  width: 100px;
  padding: 7px 0 2px;
  border-radius: 15px 15px 0 0;
  transform: translateX(-50%);
  position: absolute;
  top: -50px;
  left: 50%;
}
.pricingTable .price-value {
  color: #fff;
  background: linear-gradient(to right, #4ec2f4, #26a9f9);
  font-weight: 600;
  height: 140px;
  width: 140px;
  padding: 35px 5px 0;
  margin: 0 auto;
  border: 15px solid rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  position: relative;
  z-index: 1;
}
.pricingTable .price-value:before {
  content: "";
  background: linear-gradient(to right, #26a9f9, #4ec2f4);
  width: 95px;
  height: 95px;
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: -1;
}
.pricingTable .price-value .currency {
  font-size: 40px;
  line-height: 20px;
  vertical-align: top;
  display: inline-block;
}
.pricingTable .price-value .amount {
  font-size: 26px;
  line-height: 27px;
  display: inline-block;
}
.pricingTable .pricing-content {
  background-color: #fff;
  padding: 15px 0 20px;
  border-radius: 20px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
}
.pricingTable .title {
  color: #26a9f9;
  font-size: 33px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 15px;
}
.pricingTable .pricing-content ul {
  padding: 0;
  margin: 0 0 30px;
  list-style: none;
  display: inline-block;
}
.pricingTable .pricing-content ul li {
  color: #000;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
  padding: 0 0 0 30px;
  margin: 0 0 12px;
  position: relative;
}
.pricingTable .pricing-content ul li:last-child {
  margin-bottom: 0;
}
.pricingTable .pricing-content ul li:before {
  content: "✓";
  color: #fff;
  background: #26a9f9;
  font-family: "Font Awesome 5 Free";
  font-size: 13px;
  font-weight: 900;
  text-align: center;
  line-height: 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}
.pricingTable .pricing-content li.disable:before {
  content: "✗";
  background: #d1d1d1;
}
.pricingTable .pricingTable-signup a {
  color: #fff;
  background: #26a9f9;
  font-size: 25px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 8px 20px;
  border-radius: 15px 15px;
  transition: all 0.3s;
}
.pricingTable .pricingTable-signup a:hover {
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  box-shadow: 0 -7px 0 rgba(0, 0, 0, 0.1);
}
.pricingTable.yellow {
  background: #fdbe0e;
}
.pricingTable.yellow:after,
.pricingTable.yellow .icon,
.pricingTable.yellow .pricing-content ul li:before,
.pricingTable.yellow .pricingTable-signup a {
  background: #faa20c;
}
.pricingTable.yellow .price-value {
  background: linear-gradient(to right, #fdbe0e, #faa20c);
}
.pricingTable.yellow .price-value:before {
  background: linear-gradient(to right, #faa20c, #fdbe0e);
}
.pricingTable.yellow .pricing-content li.disable:before {
  background: #d1d1d1;
}
.pricingTable.yellow .title {
  color: #faa20c;
}

.pricingTable.platinum {
  background: #c1beba;
}
.pricingTable.platinum:after,
.pricingTable.platinum .icon,
.pricingTable.platinum .pricing-content ul li:before,
.pricingTable.platinum .pricingTable-signup a {
  background: #86938d;
}
.pricingTable.platinum .price-value {
  background: linear-gradient(to right, #b0b8bb, #7c8984);
}
.pricingTable.platinum .price-value:before {
  background: linear-gradient(to right, #606b66, #ffffff);
}
.pricingTable.platinum .pricing-content li.disable:before {
  background: #565656;
}
.pricingTable.platinum .title {
  color: #191b1a;
}

.pricingTable.pink {
  background: #f42c68;
}
.pricingTable.pink:after,
.pricingTable.pink .icon,
.pricingTable.pink .pricing-content ul li:before,
.pricingTable.pink .pricingTable-signup a {
  background: #e20845;
}
.pricingTable.pink .price-value {
  background: linear-gradient(to right, #f42c68, #e20845);
}
.pricingTable.pink .price-value:before {
  background: linear-gradient(to right, #e20845, #f42c68);
}
.pricingTable.pink .pricing-content li.disable:before {
  background: #d1d1d1;
}
.pricingTable.pink .title {
  color: #e20845;
}
@media only screen and (max-width: 990px) {
  .pricingTable {
    margin-bottom: 80px;
  }
}
</style>
<script>
import { appConfig } from "../../firebaseConfig";
export default {
  name: "Plans",
  data() {
    return {
      gold: 29,
      plantium: 49,
      switch1: false,
      length: 5,
      valid: false,
      search: "",
      musicUrl: "",
      musicRules: [
        v => !!v || "Music URL is required",
        v => /\.(?:wav|mp3)$/i.test(v) || "Music must be valid"
      ],
      selected: null,
      notificationValues: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      myitems: [],
      latitude: "",
      longitude: "",
      obj: {
        appVibration: {
          seconds: "",
          vibration: ""
        },
        battryPercentage: "",
        isCharging: "",
        bluetooth: "",
        brightness: "",
        flashlight: "",
        mobileData: "",
        mobileDataType: "",
        musicUrl: {
          music: "",
          url: ""
        },
        sound: ""
      },
      color: "",
      mode: "",
      snackbar: false,
      text: "Hello, I'm a snackbar",
      timeout: 6000,
      x: null,
      y: "top"
    };
  },
  mounted: function() {
    this.getObj();
  },
  watch: {
    switch1(switch1) {
      //called whenever switch1 changes
      console.log(switch1);
      if (switch1) {
        console.log("yearly");
        var mux = this.gold * 12;
        var muxp = this.plantium * 12;
        this.gold = mux - mux / 15;
        this.plantium = muxp - muxp / 15;
      } else {
        console.log("monthly");
        this.gold = 29;
        this.plantium = 49;
      }
    }
  },
  methods: {
    async myD() {
      if (this.selected == null) {
        console.log(this.selected);
      } else if (this.selected == "Warriyo") {
        console.log(this.selected);
      } else if (this.selected == "LostSky") {
        console.log(this.selected);
      } else if (this.selected == "Jasico") {
        console.log(this.selected);
      } else if (this.selected == "Electro") {
        console.log(this.selected);
      }
    },
    getObj() {
      return appConfig
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("868068040704064")
        .on("value", snapshot => {
          this.obj = snapshot.val();
          console.log(this.obj);
        });
    },
    saveBrightness() {
      this.obj.flashlight = this.switch1;
      appConfig
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("868068040704064")
        .set(this.obj);
      this.text = "successfully Changes";
      this.snackbar = true;
      this.color = "success";
    }
  }
};
</script>